module.exports = __webpack_public_path__ + "static/media/time.c3728ade.svg";